import PropTypes from 'prop-types';

import { STOCK_TYPE } from 'Component/Product/Stock.config';
import {
    ProductConfigurableAttributesContainer as SourceProductConfigurableAttributesContainer
} from 'SourceComponent/ProductConfigurableAttributes/ProductConfigurableAttributes.container';
import { showPopup } from 'Store/Popup/Popup.action';
import { ProductType } from 'Type/ProductList.type';
import getStore from 'Util/Store';

/** @namespace Elganso/Component/ProductConfigurableAttributes/Container */
export class ProductConfigurableAttributesContainer extends SourceProductConfigurableAttributesContainer {
    static propTypes = {
        ...this.propTypes,
        onChangeColor: PropTypes.func,
        addToCart: PropTypes.func,
        allProducts: PropTypes.arrayOf(ProductType)
    };

    state = {
        showColors: false
    };

    containerFunctions = {
        ...this.containerFunctions,
        checkIsSelected: this.checkIsSelected.bind(this),
        clickColorButton: this.clickColorButton.bind(this)
    };

    containerProps() {
        const {
            product,
            onChangeColor,
            addToCart
        } = this.props;

        const { showColors } = this.state;

        return {
            ...super.containerProps(),
            product,
            onChangeColor,
            addToCart,
            showColors
        };
    }

    handleOptionClick({ attribute_code, attribute_value }) {
        const {
            updateConfigurableVariant,
            onChangeColor,
            allProducts
        } = this.props;

        if (attribute_code === 'color') {
            const primeraOcurrencia = this.props?.product?.variants?.find((obj) => obj.attributes.color.attribute_value === attribute_value);

            const preRebaja = {
                yeboyebo_carrito_promociones_fecha_hasta: primeraOcurrencia.yeboyebo_carrito_promociones_fecha_hasta,
                yeboyebo_carrito_promociones_precio: primeraOcurrencia.yeboyebo_carrito_promociones_precio
            };

            if (this.props?.mix?.block !== 'ProductCard') {
                const sku = primeraOcurrencia.sku.split('-')[0];
                let { description } = primeraOcurrencia;

                if (allProducts !== undefined && allProducts.length > 0) {
                    const padre = allProducts.find((obj) => obj.sku === sku);

                    if (padre?.description) {
                        // eslint-disable-next-line prefer-destructuring
                        description = padre.description;
                    }
                }

                // Selecciono color
                updateConfigurableVariant(attribute_code, attribute_value, false, false, true);
                onChangeColor(primeraOcurrencia.name, primeraOcurrencia.attributes.image, primeraOcurrencia.preorder, preRebaja, attribute_value, description);
            } else {
                if (primeraOcurrencia?.id) {
                    onChangeColor(primeraOcurrencia.name, primeraOcurrencia.attributes.image, primeraOcurrencia.preorder, preRebaja, attribute_value);
                }
                updateConfigurableVariant(attribute_code, attribute_value);
            }
        } else if (attribute_code === 'size' && this.props?.mix?.block === 'ProductCard') {
            const productClicked = this.getProductClicked(attribute_code, attribute_value);
            if (productClicked?.stock_status === 'OUT_OF_STOCK' || (productClicked?.stock_status === null && productClicked?.stock_item?.in_stock === false)) {
                const store = getStore();
                const { dispatch } = store;
                dispatch(showPopup(`outofstock-popup-${this.props.product.sku}`, {
                    title: __('Pop up fuera de stock'), product: this.props.product, productClicked, isOutOfStock: 1
                }));
            } else {
                updateConfigurableVariant(attribute_code, attribute_value, false, true, false);
            }
        } else {
            updateConfigurableVariant(attribute_code, attribute_value, false, false, true);
        }
    }

    checkIsSelected(attribute) {
        const { product = {}, parameters = {} } = this.props;
        const { attribute_code, attribute_value } = attribute;

        if (attribute_code === 'color') {
            const product_colors = Object.keys(product.configurable_options.color.attribute_options);

            // COMPROBAR PARAMETRO COLOR CORRESPONDE A UNO DE LOS COLORES DEL PRODUCTO
            if (!product_colors.find((e) => e === parameters.color)) {
                // Si no corresponde marcamos el color por defecto como seleccionado
                if (product_colors[0] === attribute_value) {
                    return true;
                }

                return false;
            }
        }

        // Si el color marcado corresponde con uno de los del producto lo comprobamos con la funcion correspondiente
        return this.isSelected(attribute);
    }

    isSelected({ attribute_code, attribute_value }) {
        const { parameters = {}, product } = this.props;
        const parameter = parameters[attribute_code];

        if (parameter === undefined) {
            return false;
        }

        if (parameter.length !== undefined && attribute_code !== 'size' && product?.configurable_options) {
            const product_colors = Object.keys(product.configurable_options.color.attribute_options);
            // COMPROBAR PARAMETRO COLOR CORRESPONDE A UNO DE LOS COLORES DEL PRODUCTO
            if (product_colors.find((e) => e === parameter)) {
                return parameter.includes(attribute_value);
            }

            return attribute_value === product_colors[0];
        }

        return parameter === attribute_value;
    }

    getProductClicked(attribute_code, attribute_value) {
        const { product = {}, parameters } = this.props;

        if (product?.type_id === 'configurable' && product?.variants.length > 0) {
            const size = (attribute_code === 'size') ? attribute_value : null;
            const color = (parameters?.color) ? parameters?.color : product?.attributes?.default_color?.attribute_value;

            if (product.configurable_options?.size && product.configurable_options?.color) {
                const product_colors = Object.keys(product.configurable_options.color.attribute_options);

                // COMPROBAR PARAMETRO COLOR CORRESPONDE A UNO DE LOS COLORES DEL PRODUCTO
                if (product_colors.find((e) => e === color)) {
                    const primeraOcurrencia = product?.variants.filter((obj) => obj.attributes.color.attribute_value === color).filter((obj) => obj.attributes.size.attribute_value === size);
                    return primeraOcurrencia[0];
                }
                const primeraOcurrencia = product?.variants.filter((obj) => obj.attributes.color.attribute_value === product_colors[0]).filter((obj) => obj.attributes.size.attribute_value === size);
                return primeraOcurrencia[0];
            }
            if (product.configurable_options?.size) {
                const primeraOcurrencia = product?.variants.filter((obj) => obj.attributes.size.attribute_value === size);
                return primeraOcurrencia[0];
            }

            return product;
        }

        return product;
    }

    getIsConfigurableAttributeAvailable({ attribute_code, attribute_value }) {
        const { parameters, variants } = this.props;

        // skip out of stock check, if variants data has not been provided
        if (!variants) {
            return true;
        }

        const isAttributeSelected = Object.hasOwnProperty.call(parameters, attribute_code);

        // If value matches current attribute_value, option should be enabled
        if (isAttributeSelected && parameters[attribute_code] === attribute_value) {
            return true;
        }

        // const parameterPairs = Object.entries(parameters);

        // const selectedAttributes = isAttributeSelected
        //     // Need to exclude itself, otherwise different attribute_values of the same attribute_code will always be disabled
        //     ? parameterPairs.filter(([key]) => key !== attribute_code)
        //     : parameterPairs;

        return variants
            .some(({ stock_status, attributes, stock_item }) => {
                const { attribute_value: foundValue } = attributes[attribute_code] || {};

                return (
                    (stock_status === STOCK_TYPE.IN_STOCK || (stock_status == null && stock_item.in_stock))
                    // Variant must have currently checked attribute_code and attribute_value
                    && foundValue === attribute_value
                    // Variant must have all currently selected attributes
                // && selectedAttributes.every(([key, value]) => attributes[key].attribute_value === value)
                );
            });
    }

    clickColorButton() {
        const { product } = this.props;
        const { showColors } = this.state;

        if (product.type_id === 'configurable') {
            if (showColors) {
                this.setState({ showColors: false });
            } else {
                this.setState({ showColors: true });
            }
        }
    }
}

export default ProductConfigurableAttributesContainer;
